import { AbstractDatabaseEntryChartBuilder } from '@/composables/charts/influx-charts/chart-builders/AbstractDatabaseEntryChartBuilder'
import { SerializedDatabaseEntryChart } from '@/composables/charts/influx-charts/chart-builders/ChartInterfaces'
import { CHART_TYPES } from '@/composables/charts/influx-charts/chart-builders/CHART_TYPES'
import { useInstanceStore } from '@/store/backendInstances'
import { GenericEntryChartResultPipeline } from '@/composables/charts/GenericEntryChartResultPipeline'
import { DocumentQuerySelect } from '@/types/Query'

export class DatabaseEntryChartBuilder extends AbstractDatabaseEntryChartBuilder {
  private readonly path: string
  private readonly timestampProperty: string

  constructor(serialized: SerializedDatabaseEntryChart) {
    super(serialized)
    this.path = serialized.path
    this.timestampProperty = serialized.timestampProperty
  }

  serialize(): SerializedDatabaseEntryChart {
    return {
      ...super.serialize(),
      path: this.path,
      chartType: CHART_TYPES.DATABASE_ENTRIES_BAR,
      timestampProperty: this.timestampProperty,
    }
  }

  protected async loadData() {
    const compiled = this.timeSetup.compile()
    const filters: DocumentQuerySelect[] = []
    if (this.additionalFilters) filters.push(...this.additionalFilters)
    if (this.transientAdditionalFilters) filters.push(...this.transientAdditionalFilters)

    filters.push({ key: this.timestampProperty, operator: '<', value: compiled.end })
    filters.push({ key: this.timestampProperty, operator: '>=', value: compiled.start })

    const groupBy: string[] = []
    if (this.groupByDimensions) groupBy.push(...this.groupByDimensions)
    if (this.transientGroupByDimensions) groupBy.push(...this.transientGroupByDimensions)

    const payload = {
      query: filters,
    }

    const entries = await useInstanceStore().genericQuery(undefined, this.path, payload)
    if (entries) {
      const resultPipeline = new GenericEntryChartResultPipeline()
      this.series = await resultPipeline.prepareData(entries, this.timestampProperty, groupBy, compiled)
      this.buildOptions()
    }
  }

  autoInferChartEntity(): string | undefined {
    return 'frontend-charts.database-entries'
  }
}
